export default "/images/d1cd67bcbb0ec89a742c1cd9b13eb45c.avif";